function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M480 496H48C39.5131 496 31.3737 492.629 25.3726 486.627C19.3714 480.626 16 472.487 16 464V32C16 27.7565 17.6857 23.6869 20.6863 20.6863C23.6869 17.6857 27.7565 16 32 16C36.2435 16 40.3131 17.6857 43.3137 20.6863C46.3143 23.6869 48 27.7565 48 32V464H480C484.243 464 488.313 465.686 491.314 468.686C494.314 471.687 496 475.757 496 480C496 484.243 494.314 488.313 491.314 491.314C488.313 494.314 484.243 496 480 496Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M156 432H116C106.452 432 97.2955 428.207 90.5442 421.456C83.7928 414.705 80 405.548 80 396V244C80 234.452 83.7928 225.295 90.5442 218.544C97.2955 211.793 106.452 208 116 208H156C165.548 208 174.705 211.793 181.456 218.544C188.207 225.295 192 234.452 192 244V396C192 405.548 188.207 414.705 181.456 421.456C174.705 428.207 165.548 432 156 432Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M300 432H260C250.452 432 241.295 428.207 234.544 421.456C227.793 414.705 224 405.548 224 396V196C224 186.452 227.793 177.295 234.544 170.544C241.295 163.793 250.452 160 260 160H300C309.548 160 318.705 163.793 325.456 170.544C332.207 177.295 336 186.452 336 196V396C336 405.548 332.207 414.705 325.456 421.456C318.705 428.207 309.548 432 300 432V432Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M443.64 432H403.64C394.092 432 384.936 428.207 378.184 421.456C371.433 414.705 367.64 405.548 367.64 396V132C367.64 122.452 371.433 113.295 378.184 106.544C384.936 99.7928 394.092 96 403.64 96H443.64C453.188 96 462.345 99.7928 469.096 106.544C475.847 113.295 479.64 122.452 479.64 132V396C479.64 405.548 475.847 414.705 469.096 421.456C462.345 428.207 453.188 432 443.64 432Z",
  fill: "currentColor"
});

var SvgBarChart = function SvgBarChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBarChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bar-chart.085276ac.svg";
export { ForwardRef as ReactComponent };